export default {
  main: "Main email address",
  invoice: "Invoice email address",
}
